import { ParcelObjectType } from "@/helpers/types/types.ts";
import { EngineStoreData } from "@/stores/EngineStore/EngineStore.ts";

export const setParcelObjectDataHelper = (
  state: EngineStoreData,
  itemId: string,
  parcelObjectType: ParcelObjectType,
) => {
  const newItems = state.cartAccommodationItems?.map((item) => {
    if (item.id === itemId) {
      return { ...item, parcelObjectType };
    }
    return item;
  });
  return { cartAccommodationItems: newItems };
};

export const setParcelObjectDimensionsHelper = (
  state: EngineStoreData,
  itemId: string,
  dimensions: string,
) => {
  const newItems = state.cartAccommodationItems?.map((item) => {
    if (item.id === itemId) {
      return { ...item, parcelObjectDimensions: dimensions };
    }
    return item;
  });
  return { cartAccommodationItems: newItems };
};

export const setParcelObjectAdditionalTentDimensionsHelper = (
  state: EngineStoreData,
  itemId: string,
  dimensions: string,
) => {
  const newItems = state.cartAccommodationItems?.map((item) => {
    if (item.id === itemId) {
      return { ...item, parcelObjectAdditionalTentDimensions: dimensions };
    }
    return item;
  });
  return { cartAccommodationItems: newItems };
};

export const setParcelObjectHasMoverHelper = (
  state: EngineStoreData,
  itemId: string,
  hasMover: boolean | undefined,
) => {
  const newItems = state.cartAccommodationItems?.map((item) => {
    if (item.id === itemId) {
      return { ...item, parcelObjectHasMover: hasMover };
    }
    return item;
  });
  return { cartAccommodationItems: newItems };
};
